import useAuth from 'core/hooks/useAuth';
import { pluralize } from 'inflected';

class SegmentFieldFormatter {
  constructor(fieldName = null) {
    const { segmentFields } = useAuth();
    this.fieldValue = segmentFields?.[fieldName];
  }

  Plural() {
    return pluralize(this.fieldValue);
  }

  Singular() {
    return this.fieldValue;
  }

  toString() {
    return this.fieldValue;
  }
}

const SegmentField = {
  get serviceRecipient() {
    return new SegmentFieldFormatter('serviceRecipient');
  },
  get serviceProvider() {
    return new SegmentFieldFormatter('serviceProvider');
  },
  get client() {
    return new SegmentFieldFormatter('client');
  },
  get service() {
    return new SegmentFieldFormatter('service');
  },
  get priceTable() {
    return new SegmentFieldFormatter('priceTable');
  },
  get record() {
    return new SegmentFieldFormatter('record');
  }
};

export { SegmentField };
